<label
  class="relative inline-flex cursor-pointer items-center justify-between"
  [class.opacity-50]="disabled()"
  [class.cursor-not-allowed]="disabled()"
>
  <ng-content></ng-content>

  <input
    type="checkbox"
    class="sr-only"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="toggleValue()"
  />

  <div
    class="relative rounded-full transition-all duration-300 ease-in-out focus-within:ring-2 focus-within:ring-primary-600 focus-within:ring-offset-2"
    [ngClass]="{
      'bg-primary-600': checked() && !disabled(),
      'bg-neutral-300': !checked() && !disabled(),
      'bg-neutral-200': disabled(),
      'w-11 h-6': size() === 'S',
      'w-14 h-7': size() === 'M',
      'w-16 h-8': size() === 'L',
    }"
  >
    <span
      class="absolute left-1 top-1/2 -translate-y-1/2 transform rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out"
      [ngClass]="{
        'w-4 h-4': size() === 'S',
        'w-5 h-5': size() === 'M',
        'w-6 h-6': size() === 'L',
        'translate-x-5': checked() && size() === 'S',
        'translate-x-7': checked() && size() === 'M',
        'translate-x-8': checked() && size() === 'L',
      }"
    ></span>
  </div>
</label>
